import { render, staticRenderFns } from "./AssociateInventoryForm.vue?vue&type=template&id=bc85a87c"
import script from "./AssociateInventoryForm.vue?vue&type=script&lang=js"
export * from "./AssociateInventoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports